import { useMemo, useState } from "react";
import { useTextos } from "../context/useTextos";
import StatusBadge from "./StatusBadge";
import { CHECKLIST_STATUS } from "../lib/checklistTemplate";

const LOCALE_POR_IDIOMA = { pt: "pt-BR", en: "en-US", es: "es-ES" };

export default function ChecklistList({ checklists, onOpen, onNew, onDelete }) {
  const { t, i18n } = useTextos();
  const localeAtual = LOCALE_POR_IDIOMA[i18n.language] || "pt-BR";
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [busca, setBusca] = useState("");

  const filtrados = useMemo(() => {
    return checklists.filter((c) => {
      if (filtroStatus !== "todos" && c.status !== filtroStatus) return false;
      if (busca) {
        const termo = busca.toLowerCase();
        const alvo = `${c.cliente.nome} ${c.veiculo.placa} ${c.veiculo.modelo}`.toLowerCase();
        if (!alvo.includes(termo)) return false;
      }
      return true;
    });
  }, [checklists, filtroStatus, busca]);

  return (
    <div className="checklist-list">
      <header className="checklist-list__header">
        <h2>{t("checklist.list_titulo")}</h2>
        <button className="btn btn--primary" onClick={onNew}>
          {t("checklist.list_novo")}
        </button>
      </header>

      <div className="checklist-list__filters">
        <input
          placeholder={t("checklist.list_buscar_placeholder")}
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />
        <select value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
          <option value="todos">{t("checklist.list_todos_status")}</option>
          <option value={CHECKLIST_STATUS.RASCUNHO}>{t("checklist.checklist_status_rascunho")}</option>
          <option value={CHECKLIST_STATUS.APROVADO}>{t("checklist.checklist_status_aprovado")}</option>
        </select>
      </div>

      {filtrados.length === 0 ? (
        <p className="empty-state">{t("checklist.list_nenhum")}</p>
      ) : (
        <div className="table-scroll">
          <table className="checklist-table">
          <thead>
            <tr>
              <th>{t("checklist.col_data")}</th>
              <th>{t("checklist.col_cliente")}</th>
              <th>{t("checklist.col_veiculo")}</th>
              <th>{t("checklist.col_placa")}</th>
              <th>{t("checklist.col_status")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtrados.map((c) => (
              <tr key={c.id} onClick={() => onOpen(c.id)} className="checklist-table__row">
                <td>{new Date(c.updatedAt).toLocaleDateString(localeAtual)}</td>
                <td>{c.cliente.nome || "—"}</td>
                <td>
                  {c.veiculo.marca} {c.veiculo.modelo}
                </td>
                <td>{c.veiculo.placa || "—"}</td>
                <td>
                  <StatusBadge status={c.status} kind="checklist" />
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn--ghost btn--small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(c.id);
                    }}
                  >
                    {t("common.excluir")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}
